import React from "react";
import { abuja, lagos, ogun } from "../constants";

const Ikeja = ({location}) => {
  return (
    <div className="flex flex-col mb-16">
      {location === 'LAGOS' && (
        <div className="w-full">
          <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-4 text-center md:px-0 px-4">
          <span className="text-transparent stroke-yellow stroke-2 font-light">Things to Do</span>  IN Ikeja GRA, Lagos
          </h2>
          <div className="w-full text-center flex justify-center">
            <p className="text-[#B2B2B2] mb-12 font-barlow text-center md:px-0 px-4 md:w-[48%]">
            Ikeja GRA is one of Lagos's most prestigious neighborhoods, offering a mix of history, culture, and modern entertainment. Here are some of the top activities you can enjoy:
            </p>
          </div>
        </div>
      )}


      {location === 'ABUJA' && (
        <div className="w-full">
          <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-4 text-center md:px-0 px-4">
          <span className="text-transparent stroke-yellow stroke-2 font-light">Things to Do</span>  IN Dawaki, Abuja
          </h2>
          <div className="w-full text-center flex justify-center">
            <p className="text-[#B2B2B2] mb-12 font-barlow text-center md:px-0 px-4 md:w-[48%]">
            Dawaki is a charming suburb of Abuja, Nigeria’s bustling capital, renowned for its natural beauty, strategic location, and a blend of cultural and modern attractions.
            </p>
          </div>
        </div>
      )}


      {location === 'OGUN' && (
        <div className="w-full">
          <h2 className="text-[#FF9900] font-bold font-trajan md:text-3xl text-2xl mb-4 text-center md:px-0 px-4">
          <span className="text-transparent stroke-yellow stroke-2 font-light">Things to Do</span>  IN Ago-Iwoye, Ogun
          </h2>
          <div className="w-full text-center flex justify-center">
            <p className="text-[#B2B2B2] mb-12 font-barlow text-center md:px-0 px-4 md:w-[48%]">
            Ago-Iwoye offers a different kind of charm, blending the tranquility of a small town with rich cultural experiences. Here are some activities to explore:
            </p>
          </div>
        </div>
      )}


      {location === 'LAGOS' && (
        <div className="flex flex-col gap-0">
          {lagos.map((item,index) => (
            <div className={`flex ${
              index % 2 === 0
                ? "md:flex-row"
                : "md:flex-row-reverse"
            } flex-col md:px-[100px] px-4 gap-12 items-center`}>
              <img src={item.imageUrl} alt="" className="md:w-[40%]" />
              <div className="">
                <h3 className={`${
                index % 2 === 0
                  ? "text-[#00A859]"
                  : "text-[#FF9900]"
              } font-bold  text-2xl mb-2`}>
                  {item.hText}
                </h3>
                <p className="text-[#B2B2B2] mb-6 font-barlow">
                {item.pText}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}


      {location === 'ABUJA' && (
        <div className="flex flex-col gap-0">
          {abuja.map((item,index) => (
            <div className={`flex ${
              index % 2 === 0
                ? "md:flex-row"
                : "md:flex-row-reverse"
            } flex-col md:px-[100px] px-4 gap-12 items-center`}>
              <img src={item.imageUrl} alt="" className="md:w-[40%]" />
              <div className="">
                <h3 className={`${
                index % 2 === 0
                  ? "text-[#00A859]"
                  : "text-[#FF9900]"
              } font-bold  text-2xl mb-2`}>
                  {item.hText}
                </h3>
                <p className="text-[#B2B2B2] mb-6 font-barlow">
                {item.pText}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {location === 'OGUN' && (
        <div className="flex flex-col gap-0">
          {ogun.map((item,index) => (
            <div className={`flex ${
              index % 2 === 0
                ? "md:flex-row"
                : "md:flex-row-reverse"
            } flex-col md:px-[100px] px-4 gap-12 items-center`}>
              <img src={item.imageUrl} alt="" className="md:w-[40%]" />
              <div className="">
                <h3 className={`${
                index % 2 === 0
                  ? "text-[#00A859]"
                  : "text-[#FF9900]"
              } font-bold  text-2xl mb-2`}>
                  {item.hText}
                </h3>
                <p className="text-[#B2B2B2] mb-6 font-barlow">
                {item.pText}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Ikeja;
